import React from 'react'
import LoginForm from '../component/loginForm/LoginForm'

export default function SignIn() {
  return (
    <div>
       <LoginForm/>
    </div>
  )
}
